import React, { Component } from 'react';
import NukaCarousel from 'nuka-carousel';


class Carousel extends Component {
  render() {
    const styles = {
      button: {
        background: 'transparent',
        border: '0 none',
        cursor: 'pointer',
        color: '#ffffff',
        fontFamily: 'Verdana',
        fontSize: '5rem',
        padding: '0 3rem',
        textShadow: '1px 1px 15px #888888'
      }
    };

    const attributes = this.props.indicators ? {} : {
      renderBottomCenterControls: null
    };

    return (
      <NukaCarousel
        className={`carousel ${this.props.controls === 'outside' ? 'external-controls' : ''}`}
        autoplay={this.props.autoplay}
        autoplayInterval={this.props.delay}
        wrapAround={this.props.wrap}
        initialSlideHeight={this.props.full ? 100 : this.props.height}
        slidesToShow={this.props.groupSize}
        framePadding={this.props.padding}
        cellSpacing={this.props.spacing}
        heightMode="max"
        {...attributes}
        renderCenterLeftControls={({ previousSlide }) => (
          <button onClick={previousSlide} style={styles.button}>&lsaquo;</button>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <button onClick={nextSlide} style={styles.button}>&rsaquo;</button>
        )}>
        {this.props.children}
      </NukaCarousel>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js